import React from 'react';
import { Tooltip, Badge, Box, Typography, Stack, Fade } from '@mui/material';
import { useOffline } from '../hooks/useOffline';
import WifiIcon from '@mui/icons-material/Wifi';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import CloudSyncIcon from '@mui/icons-material/CloudSync';

const OfflineStatus: React.FC = () => {
  const { isOnline, pendingCheckIns } = useOffline();
  const hasPending = pendingCheckIns.length > 0;

  return (
    <Tooltip 
      title={
        <Stack spacing={0.5}>
          <Typography variant="body2">
            {isOnline ? 'You are online' : 'You are currently offline'}
          </Typography>
          {hasPending && (
            <Typography variant="caption">
              {pendingCheckIns.length} check-in{pendingCheckIns.length !== 1 ? 's' : ''} pending sync
            </Typography>
          )}
        </Stack>
      }
    >
      <Box sx={{ px: 1, py: 0.5, borderRadius: 4, bgcolor: 'background.paper' }}>
        <Stack direction="row" spacing={1} alignItems="center">
          {isOnline ? (
            <>
              <WifiIcon 
                color="success" 
                fontSize="small" 
                sx={{ 
                  animation: 'pulse 2s infinite',
                  '@keyframes pulse': {
                    '0%': { opacity: 0.7 },
                    '50%': { opacity: 1 },
                    '100%': { opacity: 0.7 },
                  }
                }}
              />
              <Typography variant="caption" color="success.main" sx={{ fontWeight: 500 }}>
                Online
              </Typography>
            </>
          ) : (
            <>
              <WifiOffIcon color="error" fontSize="small" />
              <Typography variant="caption" color="error" sx={{ fontWeight: 500 }}>
                Offline
              </Typography>
            </>
          )}
          
          {hasPending && (
            <Fade in={hasPending}>
              <Badge
                badgeContent={pendingCheckIns.length}
                color="error"
                sx={{
                  '& .MuiBadge-badge': {
                    right: -3,
                    top: 2,
                    border: '2px solid white',
                  },
                }}
              >
                <CloudSyncIcon color="action" fontSize="small" />
              </Badge>
            </Fade>
          )}
        </Stack>
      </Box>
    </Tooltip>
  );
};

export default OfflineStatus;
